import { FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material'
import { tokens, Typography } from 'ComponentLibrary'

type ReferencePickerProps<T extends string> = {
    label: string
    options: { value: T; label: string }[]
    selection: T
    setSelection: (selection: T) => void
}

export const ReferencePicker = <T extends string>({ label, options, selection, setSelection }: ReferencePickerProps<T>) => {
    return (
        <RadioGroup value={selection} onChange={(_, newValue) => setSelection(newValue as T)}>
            <Stack direction="row" gap={tokens.SizingSpacing100} alignItems="center">
                <Typography variant="bodyTextSmall" color={tokens.ColorTextDefault} style={{ paddingRight: tokens.SizingSpacing150 }}>
                    {label}
                </Typography>
                {options.map(({ value, label }) => (
                    <FormControlLabel
                        key={label}
                        value={value}
                        control={<Radio size="small" style={{ padding: tokens.SizingSpacing075 }} color="success" />}
                        label={label}
                    />
                ))}
            </Stack>
        </RadioGroup>
    )
}
